import { useAppSelector } from 'app';

export function hasPermission(
    featureName: string |  undefined
  ): boolean {
    let userPermissions = useAppSelector((state) => state.user?.userPermissions);
    
    if (userPermissions?.length === 0 || !featureName?.trim()) {
      return false;
    }
  
    return userPermissions.some(
      (perm) =>
        perm.featureName === featureName.trim() &&
        perm.permission === true // Explicit equality for clarity
    );
  }

  export function useHasTextToPayPermission(): boolean {

      const textToPayPaymentGateway = useAppSelector(
      (state) => state.user?.textToPayPaymentGateway
    );
    return (
      textToPayPaymentGateway === TargetPayPaymentGateway.Ayden ||
      textToPayPaymentGateway === TargetPayPaymentGateway.Gravity ||
      textToPayPaymentGateway === TargetPayPaymentGateway.DIS

    );
  }

  export function isAdminUser(): boolean {
    const isAdmin = useAppSelector((state) => state.user?.isUserAdmin);
    return isAdmin === true;
  }
  
  export const TargetPayPaymentGateway = {
    Gravity: 1,
    Ayden: 2,
    DIS: 3
 } as const;

